<template>
  <div class="px-4 py-4">
    <div>
      <p>
          We explore the univariate associations between the PRISM sensitivity profiles and the genomic
          features or genetic dependencies by computing Pearson correlations and associated p-values. 
          <br><br>
          In order to allow for analysis of relationships at particular doses and overall, correlations are done at each dose <span v-html="doseMetrics"></span>. The dose or curve-level statistic used for correlation is noted in the “Dose” column.
          <br><br>
          For each dataset, the q-values are computed from p-values using the
          <a href="https://www.jstor.org/stable/2346101" target="Benjamini_Hochberg">Benjamini-Hochberg algorithm.</a>
          Associations with q-values above 0.1 are filtered out.
    
        </p>
  </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';
export default {
  name: 'correlation-analysis-drawer',
  data: () => ({

  }),
  computed:{
    meta(){
          const section_id = "correlation-analysis";
          const screen = this.$route.params.screen;
          const version_meta = portalContent.getVersionMetadata(screen, section_id);
          return version_meta
        },
        doseMetrics(){
          return portalContent.getIncludedDoseMetrics(this.meta)
        }
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
